__turbopack_context__.v({
  "field": "input-module__7BXsdW__field",
  "hasLeading": "input-module__7BXsdW__hasLeading",
  "hasTrailing": "input-module__7BXsdW__hasTrailing",
  "input": "input-module__7BXsdW__input",
  "inputWrap": "input-module__7BXsdW__inputWrap",
  "label": "input-module__7BXsdW__label",
  "leading": "input-module__7BXsdW__leading",
  "msg": "input-module__7BXsdW__msg",
  "msgError": "input-module__7BXsdW__msgError",
  "required": "input-module__7BXsdW__required",
  "select": "input-module__7BXsdW__select",
  "selectChevron": "input-module__7BXsdW__selectChevron",
  "selectWrap": "input-module__7BXsdW__selectWrap",
  "selectWrapInline": "input-module__7BXsdW__selectWrapInline",
  "textarea": "input-module__7BXsdW__textarea",
  "trailing": "input-module__7BXsdW__trailing",
});
